import { ChatState } from 'features/chat/types';

export const resetMessages = (state: ChatState) => {
  state.entities = {};
  state.publicIds = [];
  state.privateChat.chats = {};
  // optimisticImageBlobs is intentionally left in place: cancelAllChatUploadsSaga
  // still needs the URLs to revoke them, and clears the map afterwards via
  // chatBlobUrlsCleared.
};
